import { Observable } from 'rxjs';
import { Type } from '@angular/core';
import { OmniSearchProvider, OmniSearchResult, OmniSearchResultComponent } from '@brighthub/search';

export abstract class BrightAiOmniSearchProvider<T = any> implements OmniSearchProvider<T> {
  abstract id: string;
  abstract label: string;
  abstract rolesAllowed: string[];
  abstract search(query: string): Observable<OmniSearchResult<T>[]>;
  abstract loadComponent: () => Promise<Type<OmniSearchResultComponent<T>>>;

  subApp = 'BrightAI';
  description?: string;
  shortcut?: string;
}
